import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';

const StyledMapComponent = styled.div`
  position: relative;
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
  @media print {
    page-break-inside: avoid;
    margin-bottom: 30px;
    display: block;
  }
`;

const MapWrapper = styled.div`
  width: 100%;
  height: ${props => (props.heightInPx ? `${props.heightInPx}px` : '500px')};
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

class MapComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    srcDoc.set(this.iframeRef.current, this.props.data); // eslint-disable-line no-script-url, no-undef
  }

  render() {
    const { title, info } = this.props;
    return (
      <StyledMapComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <MapWrapper heightInPx={this.props.heightInPx}>
          <iframe
            ref={this.iframeRef}
            title={`Title${parseInt(Math.random() * 100000, 10)}`}
            style={{
              width: '100%',
              height: '100%',
              border: 0
            }}
          />
          <UpdatedDate placementH={`left`}>{`letztes Update: ${
            this.props.lastUpdated
          }`}</UpdatedDate>
        </MapWrapper>
      </StyledMapComponent>
    );
  }
}

export default MapComponent;
